import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { instance } from "@/lib/axios/instance";
import { GetClientJobBoardsResponse } from "@/types/response/GetClientJobBoardsResponse";

interface UseClientJobBoardsParams {
  clientId?: string;
  search?: string;
  enabled?: boolean;
}

export function useClientJobBoards({
  clientId,
  search,
  enabled = true,
}: UseClientJobBoardsParams) {
  return useQuery<GetClientJobBoardsResponse, AxiosError>({
    queryKey: ["clientJobBoards", clientId, search],
    enabled: enabled,
    queryFn: () =>
      instance
        .get(`/api/v2/JobBoards`, {
          params: {
            clientId: clientId || undefined,
            page: 1,
            pageSize: 100,
            search,
          },
        })
        .then((res) => res.data),
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
}
